import Image from 'next/image';
import React, { useState } from 'react';
import { TypeAnimation } from 'react-type-animation';
import faqsimgtwo from '../../public/images/faqsone.png';
import FaqsForm from './faqsform';

const Faqsbaner = () => {
  const [faqForm, setFaqForm] = useState(false);

  const handleFaqFoem = () => {
    setFaqForm(true);
  }
  return (
    <>
    {faqForm && (
    <FaqsForm
    isOpen={faqForm}
    onClose={() => setFaqForm(false)}/>)
    }
      <div className='animatedfaqsbg relative'>
        <div className='bg-[#51a8ff36] absolute inset-0'>
          <div className='absolute inset-0 2xl:mx-24 xl:mx-20 lg:mx-20 md:mx-20 sm:mx-10 mx-5'>
            <div className="nice-typed-input">
              <span id="nice-typed" className="nice-typed">
                <TypeAnimation
                  sequence={[
                    'How to create a WordPress Knowledge Base?|',
                    1000,
                    'How can I give fast answer|',
                    1000,
                    'Scale your support with a help center |',
                    1000
                  ]}
                  wrapper="span"
                  speed={50}
                  repeat={Infinity}
                />
              </span>
              <i aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6"><path d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" /></svg></i>
            </div>
            <div className='flex flex-col mt-[38px] relative'>
              <div className='text-xl font-bold text-[#FF5349]'>#WeDriveEasyCampus</div>
              <br /><br />
              <div className='text-center justify-center'>
                <h2 className='font-bold mt-5'>Do You Have Questions?</h2>
                <h3>We have answers [well, most of the time!]</h3>
                <div className='relative flex justify-center mt-3'>
                  <Image src={faqsimgtwo} alt='how to prepare resume for freshers' height={100} width={100}
                    className='h-20 w-20' />
                </div>
                <p className='mt-2 lg:text-2xl text-xl font-extralight lg:px-56'>
                  Below you'll find answers to the most common questions you may<br/> have on
                  Campus Placement Drive and Easy Campus. Also feel free to{" "}
                  <span className='cursor-pointer text-[#0000f7]' onClick={handleFaqFoem}>Contact Us, </span>
                  If you can't find the answer you're looking for.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Faqsbaner;
